import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import PerformancePlugin from '~/performance/vue_performance_plugin';
import initRepositoryPage from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/init_repository_page.js?vue3';

Vue.use(PerformancePlugin, {
  components: ['SimpleViewer', 'BlobContent'],
});

export default function setupVueRepositoryList() {
  return initRepositoryPage();
}
